import React from "react";
import PlusMinButtons from "../../../common/PlusMinButtons";
import AutoComplete from "../../../common/AutoComplete";
import Row from "../../../common/Row";
import PropTypes from "prop-types";

const GemeenteComponent = props => {
	const {
		gemeente,
		hoofdgemeenten,
		minButtonEnabled,
		plusButtonEnabled,
		disabled,
		onPlusButtonClick,
		onMinButtonClick,
		onChange,
		index,
		errors,
		validationMessageType
	} = props;

	return (
		<Row>
			<AutoComplete
				name={"gemeente_" + index}
				size={5}
				label=""
				items={hoofdgemeenten}
				onChange={onChange}
				disabled={disabled}
				value={gemeente.id}
				validationMessage={errors ? errors["gemeente"] : ""}
				validationMessageType={validationMessageType}
			/>
			<PlusMinButtons
				minButtonEnabled={minButtonEnabled && !disabled}
				plusButtonEnabled={plusButtonEnabled && !disabled}
				onMinButtonClick={onMinButtonClick}
				onPlusButtonClick={onPlusButtonClick}
				size={1}
			/>
		</Row>
	);
};

GemeenteComponent.propTypes = {
	gemeente: PropTypes.object,
	hoofdgemeenten: PropTypes.array,
	minButtonEnabled: PropTypes.bool,
	plusButtonEnabled: PropTypes.bool,
	disabled: PropTypes.bool,
	onPlusButtonClick: PropTypes.func.isRequired,
	onMinButtonClick: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	index: PropTypes.number,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string
};

export default GemeenteComponent;
